// extracted by mini-css-extract-plugin
export default {"outerContainer":"ngFhW0","sizing":"puNFMS","double":"HkgIzc","imageContainer":"icIBQ5","image":"EnVTaR","imageBackground":"rkXkmK"};